import React, { PureComponent } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';

import InputWrapper from '../../forms/InputWrapper.js';
import api from '../../../api/index.js';
import './deadplantsform.scss';

class DeadPlantsForm extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			effectiveDate: new Date(),
			value: 0
		}
		this.onChange = this.onChange.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
	
	onChange(e) {
		this.setState({[e.target.name]: [e.target.value]});
	}
	
	handleDateChange(date) {
		this.setState({
			effectiveDate: date
		});
	}
	
	async onSubmit(e) {
		e.preventDefault();
		try {
			let r = await api.post('farms/' + this.props.FarmID + '/fields/' + this.props.FieldID + '/rows/' + this.props.RowID + '/dead', {
				effectiveDate: moment(this.state.effectiveDate).format('YYYY-MM-DD HH:mm:ss'),
				value: this.state.value
			});
			api.success('Dead plants updated', r);
			if (this.props.onUpdated)
				this.props.onUpdated(r);
		} catch(e) {
			api.handleExceptions(e);
		}
	}
	
	render() {
		return (
			<form onSubmit={this.onSubmit} className={(this.props.className || '') + ' deadplants'}>
				<InputWrapper label="Effective date" id="effectiveDate" info={"There were this many dead plants in row " + this.props.RowNumber + ", as of.."}>
				<DatePicker
					selected={this.state.effectiveDate}
					onChange={this.handleDateChange}
				/>
				</InputWrapper>
				
				<label>Number of dead plants</label>
				<input type="text" name="value" value={this.state.value} onChange={this.onChange} placeholder="Number of dead plants" />
				<input type="submit" value="Save dead plants" />
			</form>
		);
	}
}

export default DeadPlantsForm;
